import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subscription} from "rxjs";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import { LookupService } from 'src/app/services';
import { MarketingService } from '../../services/marketing.service';
import { IDealCard } from 'src/app/modules/shared/models';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DataSource } from '@angular/cdk/collections';
import { MarketingItemDto } from '../../interafaces/marketing-dto';

@Component({
  selector: 'app-create-edit-campaign',
  templateUrl: './create-edit-campaign.component.html',
  styleUrls: ['./create-edit-campaign.component.scss']
})
export class CreateEditCampaignComponent implements OnInit {

  // displayedColumns: string[] = ['firstName', 'lastName', 'email', 'company', 'actions']
  liveDeals$: Observable<IDealCard[]>;

  fg: FormGroup;
//   dataSource: IMarketingTarget[] = [
//     {
//       firstName: 'Reza',
//       lastName: 'Khanahmadi',
//       email: 'rk@rondeivu.com'
//     },
//     {
//       firstName: 'John',
//       lastName: 'Nash',
//       email: 'j@rondeivu.com'
//     },

// ];
 
  constructor(
    public lookupService: LookupService,
    private marketingService: MarketingService,
    public dialogRef: MatDialogRef<CreateEditCampaignComponent>,
              @Inject(MAT_DIALOG_DATA) public data: MarketingItemDto) {

    // dealing the deal
    this.liveDeals$ = marketingService.getDeals();

    this.fg = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      dealIds: new FormControl<string[]>([]),
      message: new FormControl('', [Validators.required])
    });

    if (!!this.data) {
      console.log("Injected data", this.data)
      this.fg.patchValue(this.data);
    }
  }

  ngOnInit(): void {

  }

  saveDraft() {
    console.log('Save Draft clicked', this.fg.value);
    // this.marketingService.
  }

  sendEmail() {
    console.log('Send Email clicked', this.fg.value);
  }

}
